import React, { useState, useEffect, useRef } from 'react';
import { aNumero, formatearConPuntos, limpiarInput } from '../../services/numeros';
import { formatearFechaInput, isoAFechaDisplay, fechaDisplayAIso } from '../../services/fechas';
import { ReactComponent as ComprasIcon } from '../../assets/icons/ComprasIcon.svg';
import { Listbox, ListboxButton, ListboxOptions, ListboxOption, Combobox  } from '@headlessui/react';
import { ReactComponent as SearchIcon } from '../../assets/icons/SearchIcon.svg';
import { getAuth } from 'firebase/auth';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../services/firebase';
import { invalidarCacheColecciones } from '../../services/dataCache';
import { ReactComponent as ClipIcon } from '../../assets/icons/ClipIcon.svg';
import LoadingSpinner from '../LoadingSpinner';

const ComprasForm = () => {
const formatNumberWithDots = formatearConPuntos;
const normalizePrice = aNumero;
const navigate = useNavigate();
const { id } = useParams();
const isEditing = !!id;
const [isLoading, setIsLoading] = useState(false);
const [saveState, setSaveState] = useState('idle'); // 'idle' | 'saved' | 'error'
const [errorMsg, setErrorMsg] = useState('');
const [loadingCompra, setLoadingCompra] = useState(isEditing);
const [progress, setProgress] = useState(0);
const [proveedores, setProveedores] = useState([]);
const [loadingProveedores, setLoadingProveedores] = useState(true);
const [selectedProveedor, setSelectedProveedor] = useState(null);
const location = useLocation();
const [ordenDeCompraId, setOrdenDeCompraId] = useState(null);
const [pdfFile, setPdfFile] = useState(null);
const fileInputRef = useRef(null);
const [query, setQuery] = useState('');


const formatNumberToARS = (number) => {
const value = parseFloat(number);
if (isNaN(value)) {
return '';
}
return new Intl.NumberFormat('es-AR', {
minimumFractionDigits: 2,
maximumFractionDigits: 2,
}).format(value);
};
const handleFileChange = (e) => {
if (e.target.files[0]) {
setPdfFile(e.target.files[0]);
}
};
const handleButtonClick = () => {
fileInputRef.current.click();
};
const diasConteoMap = {
'Diario': 1,
'Semanal': 7,
'Mensual': 30,
'Trimestral': 90,
'Semestral': 180,
'Anual': 365
};
const opcionesConteo = ["Diario", "Semanal", "Mensual", "Trimestral", "Semestral", "Anual"];
const [articulos, setArticulos] = useState([
{
nombre: '',
categoria: '',
tipoUnidad: '',
cantidadUnidades: '',
tipoDivisa: 'Pesos',
precioUnidad: '',
descuentoAplicado: '',
diasConteo: '',
existenciasMinimas: '',
existenciasMaximas: '',
},
]);
const [formData, setFormData] = useState({
tipoFactura: '',
numeroFactura: '',
modalidadPago: '',
numeroCheque: '',
bancoEmisor: '',
vencimientoCheque: '',
montoCheque: '',
impuestoCheque: '',
descuentoCol2: '',
ivaAplicado: '',
percepcionIIBB: '',
totalSinImpuestos: '',
totalConImpuestos: '',
costosEnvio: '',
fechaCompra: '',
fechaEntrega: '',
fechaPago: '',
tipoDivisa: 'Pesos',
razonSocial: '',
cuit: '',
calle: '',
telefono: '',
correoElectronico: '',
nombreVendedor: '',
altura: '',
piso: '',
unidad: '',
codigoPostal: '',
ciudad: '',
pais: '',
rubro: ''
});
useEffect(() => {
const fetchProveedores = async () => {
try {
const res = await fetch('https://backend-288175208699.europe-west1.run.app/proveedores', {
headers: { Authorization: `Bearer ${await getAuth().currentUser.getIdToken()}` },
});
const data = await res.json();
const proveedoresOrdenados = data.sort((a, b) => 
                a.razonSocial.localeCompare(b.razonSocial)
            );
            setProveedores(proveedoresOrdenados);
            setLoadingProveedores(false);
} catch (err) {
console.error('Error al cargar proveedores:', err);
setLoadingProveedores(false);
}
};
fetchProveedores();
}, []);
useEffect(() => {
if (location.state && location.state.ordenDeCompra) {
const orden = location.state.ordenDeCompra;
setOrdenDeCompraId(orden.id);
setFormData({
...formData,
razonSocial: orden.razonSocial || '',
cuit: orden.cuit || '',
calle: orden.calle || '',
telefono: orden.telefono || '',
correoElectronico: orden.correoElectronico || '',
nombreVendedor: orden.nombreVendedor || '',
altura: orden.altura || '',
piso: orden.piso || '',
unidad: orden.unidad || '',
codigoPostal: orden.codigoPostal || '',
ciudad: orden.ciudad || '',
pais: orden.pais || '',
rubro: orden.rubro || '',
});
if (orden.articulos && orden.articulos.length > 0) {
setArticulos(orden.articulos.map(articulo => ({
nombre: articulo.nombre || '',
categoria: articulo.categoria || '',
tipoUnidad: articulo.tipoUnidad || '',
cantidadUnidades: articulo.cantidadUnidades || '',
tipoDivisa: articulo.tipoDivisa || 'Pesos',
precioUnidad: normalizePrice(articulo.precioUnidad),
descuentoAplicado: articulo.descuentoAplicado || '',
diasConteo: articulo.diasConteo || '',
existenciasMinimas: articulo.existenciasMinimas || '',
existenciasMaximas: articulo.existenciasMaximas || '',
})));
}
}
}, [location.state]);
useEffect(() => {
if (!isEditing) return;
const cargarCompra = async () => {
try {
const snap = await getDoc(doc(db, 'compras', id));
if (!snap.exists()) {
setLoadingCompra(false);
return;
}
const compra = snap.data();
setFormData(prev => ({
...prev,
...compra,
fechaCompra: isoAFechaDisplay(compra.fechaCompra),
fechaEntrega: isoAFechaDisplay(compra.fechaEntrega),
fechaPago: isoAFechaDisplay(compra.fechaPago),
vencimientoCheque: isoAFechaDisplay(compra.vencimientoCheque),
}));
if (compra.razonSocial) {
setSelectedProveedor({
razonSocial: compra.razonSocial,
cuit: compra.cuit,
calle: compra.calle,
telefono: compra.telefono,
correoElectronico: compra.correoElectronico,
nombreVendedor: compra.nombreVendedor,
});
}
if (compra.articulos && compra.articulos.length > 0) {
// Se parte de "...articulo" (no de un objeto armado a mano) para que
// viajen de vuelta al backend intactos campos que no se tocan acá pero
// que sí están en el documento (ej. idCompra): si se arma el objeto
// campo por campo, cualquier propiedad ausente en esta lista se pierde
// y el backend la ve como "modificada", rechazando la edición aunque
// solo se haya tocado la categoría. Los "?? ''" (en vez de "||") son
// por lo mismo: un 0 legítimo (ej. descuentoAplicado: 0) no se puede
// pisar con '' porque el backend lo vuelve a mandar como null y tampoco
// coincide con el valor guardado.
setArticulos(compra.articulos.map(articulo => ({
...articulo,
nombre: articulo.nombre || '',
categoria: articulo.categoria || '',
tipoUnidad: articulo.tipoUnidad || '',
cantidadUnidades: articulo.cantidadUnidades ?? '',
tipoDivisa: articulo.tipoDivisa || compra.tipoDivisa || 'Pesos',
precioUnidad: normalizePrice(articulo.precioUnidad),
descuentoAplicado: articulo.descuentoAplicado ?? '',
diasConteo: articulo.diasConteo ?? '',
existenciasMinimas: articulo.existenciasMinimas ?? '',
existenciasMaximas: articulo.existenciasMaximas ?? '',
})));
}
} catch (error) {
console.error('Error al cargar la compra a editar:', error);
} finally {
setLoadingCompra(false);
}
};
cargarCompra();
}, [isEditing, id]);
useEffect(() => {
    const calculateTotalSinImpuestos = () => {
        let total = 0;
        articulos.forEach(articulo => {
            const cantidad = normalizePrice(articulo.cantidadUnidades);
            const precio = normalizePrice(articulo.precioUnidad);
            const descuento = normalizePrice(articulo.descuentoAplicado) / 100;
            if (!isNaN(cantidad) && !isNaN(precio)) {
                const precioConDescuento = precio * (1 - descuento);
                const subtotal = cantidad * precioConDescuento;
                total += subtotal;
            }
        });

        // Total exacto: redondeo a centavos una sola vez, sin truncar en cada paso
        const finalTotalSinImpuestos = Math.round(total * 100) / 100;

        setFormData(prevFormData => ({
            ...prevFormData,
            totalSinImpuestos: finalTotalSinImpuestos,
        }));
    };
    calculateTotalSinImpuestos();
}, [articulos]);


useEffect(() => {
    const calculateTotalConImpuestos = () => {
        let totalSinImp = formData.totalSinImpuestos;
        let descuentoTotal = normalizePrice(formData.descuentoCol2) || 0;
        let iva = normalizePrice(formData.ivaAplicado) || 0;
        let percepcion = normalizePrice(formData.percepcionIIBB) || 0;
        let costosEnvio = normalizePrice(formData.costosEnvio) || 0;

        if (!isNaN(totalSinImp)) {
            // 1. Aplicar descuento general (exacto, sin truncar)
            let montoConDescuento = totalSinImp * (1 - descuentoTotal / 100);

            // 2. Calcular IVA (exacto, sin truncar)
            let montoIva = montoConDescuento * (iva / 100);

            // 3. Calcular percepción IIBB (exacto, sin truncar)
            let montoPercepcion = montoConDescuento * (percepcion / 100);

            // 4. Sumar todo junto con costos de envío, redondeando a centavos una sola vez al final
            let total = montoConDescuento + montoIva + montoPercepcion + costosEnvio;
            total = Math.round(total * 100) / 100;

            setFormData(prevFormData => ({
                ...prevFormData,
                totalConImpuestos: total,
            }));
        }
    };

    calculateTotalConImpuestos();
}, [formData.totalSinImpuestos, formData.descuentoCol2, formData.ivaAplicado, formData.percepcionIIBB, formData.costosEnvio]);



const formatCuit = (value) => {
const digits = value.replace(/\D/g, '');
if (digits.length <= 2) return digits;
if (digits.length <= 10) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
return `${digits.slice(0, 2)}-${digits.slice(2, 10)}-${digits.slice(10, 11)}`;
};
const handleCuitChange = (e) => {
const formatted = formatCuit(e.target.value);
setFormData({
...formData,
cuit: formatted,
});
};
const handleArticuloChange = (e, index) => {
const { name, value } = e.target;
const newArticulos = [...articulos];
newArticulos[index][name] = value;
setArticulos(newArticulos);
};
const handleArticuloListboxChange = (name, value, index) => {
const newArticulos = [...articulos];
newArticulos[index][name] = value;
setArticulos(newArticulos);
};
const handleConteoChange = (value, index) => {
const numericValue = diasConteoMap[value];
const newArticulos = [...articulos];
newArticulos[index]['diasConteo'] = numericValue;
setArticulos(newArticulos);
};
const handleAddArticulo = () => {
setArticulos([
...articulos,
{
nombre: '',
// Si el primer artículo es Servicios, la compra queda "trabada" en esa
// categoría: los artículos que se agreguen después nacen ya como
// Servicios (no tiene sentido mezclar una factura de luz con un insumo).
categoria: esServicio ? 'Servicios' : '',
tipoUnidad: '',
cantidadUnidades: '',
tipoDivisa: formData.tipoDivisa,
precioUnidad: '',
descuentoAplicado: '',
diasConteo: '',
existenciasMinimas: '',
existenciasMaximas: '',
},
]);
};
const handleRemoveArticulo = (index) => {
const newArticulos = articulos.filter((_, i) => i !== index);
setArticulos(newArticulos);
};
const handleChange = (e) => {
const { name, value } = e.target;
setFormData({ ...formData, [name]: value });
};
const handleArticuloChangeFormatted = (e, index) => {
const { name, value } = e.target;
const newArticulos = [...articulos];
newArticulos[index][name] = limpiarInput(value);
setArticulos(newArticulos);
};
const handleChangeFormatted = (e) => {
const { name, value } = e.target;
setFormData(prev => ({
...prev,
[name]: limpiarInput(value)
}));
};
const handleFechaChange = (e) => {
const { name, value } = e.target;
setFormData(prev => ({
...prev,
[name]: formatearFechaInput(value)
}));
};
const handleSubmit = async (e) => {
e.preventDefault();
setSaveState('idle');
setErrorMsg('');
const camposFecha = [
{ name: 'fechaCompra', label: esServicio ? 'Fecha de emisión' : 'Fecha de compra' },
{ name: 'fechaEntrega', label: esServicio ? 'Fecha de vencimiento' : 'Fecha de entrega' },
{ name: 'fechaPago', label: 'Fecha de pago' },
{ name: 'vencimientoCheque', label: 'Fecha de vencimiento del cheque' },
];
const fechasISO = {};
for (const campo of camposFecha) {
const valor = formData[campo.name];
if (!valor) {
fechasISO[campo.name] = '';
continue;
}
const iso = fechaDisplayAIso(valor);
if (!iso) {
setSaveState('error');
setErrorMsg(`${campo.label} no es una fecha válida. Usá el formato dd/mm/aaaa.`);
return;
}
fechasISO[campo.name] = iso;
}
setIsLoading(true);
setProgress(0);
const user = getAuth().currentUser;
if (!user) {
setIsLoading(false);
return;
}
try {
const idToken = await user.getIdToken();
const datosParaEnviar = {
...formData,
...fechasISO,
articulos: articulos,
ordenDeCompraId: ordenDeCompraId,
};
const interval = setInterval(() => {
setProgress((prev) => Math.min(prev + 5, 95));
}, 100);
const metodo = isEditing ? 'PUT' : 'POST';
const url = isEditing
? `https://backend-288175208699.europe-west1.run.app/editar-compra/${id}`
: 'https://backend-288175208699.europe-west1.run.app/crear-compra';
const fetchOptions = pdfFile
? {
method: metodo,
headers: {
Authorization: `Bearer ${idToken}`,
},
body: (() => {
const fd = new FormData();
fd.append('data', JSON.stringify(datosParaEnviar));
fd.append('pdf', pdfFile);
return fd;
})(),
}
: {
method: metodo,
headers: {
'Content-Type': 'application/json',
Authorization: `Bearer ${idToken}`,
},
body: JSON.stringify(datosParaEnviar),
};
const res = await fetch(url, fetchOptions);
clearInterval(interval);
setProgress(100);
const data = await res.json();
if (!res.ok) throw new Error(data.error || (isEditing ? 'Error al guardar los cambios' : 'Error al crear la compra'));
invalidarCacheColecciones();
setSaveState('saved');
setTimeout(() => {
navigate('/compras');
}, 800);
} catch (error) {
console.error(error);
setSaveState('error');
setErrorMsg(error.message || (isEditing ? 'Error al guardar los cambios' : 'Error al crear la compra'));
setIsLoading(false);
setProgress(0);
}
};
const tiposDivisa = ["Pesos", "Dólares", "Reales", "Euros"];
const abreviaturasDivisa = { Pesos: "$", "Dólares": "US$", Reales: "R$", Euros: "€" };
const modalidadesPago = ["Cheque", "Contado", "Tarjeta de credito", "Tarjeta de débito", "Transferencia"];
const tiposFactura = ["A", "B", "C", "X"];
const tiposUnidad = ["Unidad", "Kilos", "Gramos", "Litro", "Centilitros", "Mililitros"];
const categorias = ["Activos", "Almacén", "Depósito", "Enología", "Finca", "Insumos", "Servicios", "Utilitarios"];
const abreviaturas = {
Unidad: "u", Kilos: "kg", Gramos: "gr", Litro: "lts",
Centilitros: "cl", Mililitros: "ml"
};
const handleTipoDivisaChange = (value) => {
setFormData({ ...formData, tipoDivisa: value });
const newArticulos = articulos.map(articulo => ({
...articulo,
tipoDivisa: value,
}));
setArticulos(newArticulos);
};

const filteredProveedores =
  query === ''
    ? proveedores
    : proveedores.filter((proveedor) => {
        return proveedor.razonSocial.toLowerCase().includes(query.toLowerCase());
      });

// Ordena la lista de proveedores filtrada alfabéticamente
const sortedProveedores = [...filteredProveedores].sort((a, b) =>
  a.razonSocial.localeCompare(b.razonSocial)
);
// La compra es "de servicios" si el primer artículo tiene esa categoría.
// No hay stock, unidades ni envío en una factura de luz/gas/internet: en
// ese caso el resto del form muestra sus campos propios (monto en vez de
// precio unitario, fecha de vencimiento en vez de entrega, etc.).
const esServicio = articulos[0]?.categoria === 'Servicios';
if (loadingCompra) {
return <LoadingSpinner />;
}
return (
<div style={{ padding: '0 16px',overflow:'hidden',height:'100%' }}>
<header className="trazabilidad-header">
<div className="header-content">
<h1>Compras</h1>
</div>
</header>
<div className="container" style={{ margin: '0 10px' }}>
<div className="formtitle-container">
<div className="formicon-container">
<ComprasIcon className="formicon" style={{ height: '20px', margin: 'auto' }} />
</div>
<h1 className="formtitle">{isEditing ? 'Editar compra' : 'Ingreso al sistema'}</h1>
</div>
<hr className="divider" />
<form onSubmit={handleSubmit} className="form">
{isEditing && (
<p style={{ fontFamily: 'Effra', fontSize: '13px', color: '#e65c5c', margin: '0 0 10px' }}>
Los artículos, cantidades, precios y totales no se editan: ya sumaron al stock.
Si eso está mal, anulá la compra y cargala de nuevo. La categoría de cada
artículo sí se puede corregir, porque no mueve stock ni plata.
</p>
)}
<div className="columns-container">
<div className="column long">
{/* En edición, los artículos quedan bloqueados: ya impactaron en stock.
    fieldset[disabled] deshabilita nativamente todo lo que tenga adentro.
    La categoría queda afuera del fieldset a propósito: es lo único que sí
    se puede corregir con la compra ya cargada (no mueve stock ni plata). */}
{articulos.map((articulo, index) => (
<>
<fieldset disabled={isEditing} style={{ border: 'none', padding: 0, margin: 0, display: 'contents' }}>
<div className='input-group'>
<input
type="text"
name="nombre"
placeholder="Descripción del articulo"
value={articulo.nombre}
onChange={(e) => handleArticuloChange(e, index)}
className="input"
/>
</div>
</fieldset>
<div className="input-group">
<Listbox
value={articulo.categoria}
onChange={(value) => handleArticuloListboxChange('categoria', value, index)}
disabled={index > 0 && esServicio}
>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${articulo.categoria ? 'selected' : 'placeholder'}`}>
{articulo.categoria || "Categoría"}
<span className="custom-arrow-container">
<span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{/* Si el primer artículo es Servicios, el resto de la compra queda
    trabado en esa categoría: no tiene sentido mezclar una factura
    de servicio con un insumo con stock. */}
{(index > 0 && esServicio ? ['Servicios'] : categorias).map((option) => (
<ListboxOption key={option} value={option} className="custom-listbox-option">
{option}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
<fieldset disabled={isEditing} style={{ border: 'none', padding: 0, margin: 0, display: 'contents' }}>
{!esServicio && (
<>
<div className="input-group">
<Listbox
value={articulo.tipoUnidad}
onChange={(value) => handleArticuloListboxChange('tipoUnidad', value, index)}
>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${articulo.tipoUnidad ? 'selected' : 'placeholder'}`}>
{articulo.tipoUnidad || "Tipo de unidad"}
<span className="custom-arrow-container">
<span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{tiposUnidad.map((option) => (
<ListboxOption key={option} value={option} className="custom-listbox-option">
{option}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
<div className='input-group number'>
<input
type="text"
name="cantidadUnidades"
placeholder="Cantidad de unidades"
value={formatNumberWithDots(articulo.cantidadUnidades)}
onChange={(e) => handleArticuloChangeFormatted(e, index)}
className="input"
/>
<span className="unit">{articulo.tipoUnidad ? abreviaturas[articulo.tipoUnidad] : ""}</span>
</div>
</>
)}
<div className='input-group number'>
<input
type="text"
name="precioUnidad"
placeholder={esServicio ? "Monto" : "Precio unitario"}
value={formatNumberWithDots(articulo.precioUnidad)}
onChange={(e) => handleArticuloChangeFormatted(e, index)}
className="input"
/>
<span className="unit">{abreviaturasDivisa[articulo.tipoDivisa] || "$"}{esServicio ? "" : `/${articulo.tipoUnidad ? abreviaturas[articulo.tipoUnidad] : ""}`}</span>
</div>
<div className='input-group number'>
<input
type="text"
name="descuentoAplicado"
placeholder="Descuento aplicado"
value={formatNumberWithDots(articulo.descuentoAplicado)}
onChange={(e) => handleArticuloChangeFormatted(e, index)}
className="input"
/>
<span className="unit">%</span>
</div>
{!esServicio && (
<>
<label className='date-label'>Conteo de inventario</label>
<div className='input-group'>
<Listbox
value={articulo.diasConteo}
onChange={(value) => handleConteoChange(value, index)}
>
{({ open }) => (
<>
<ListboxButton
className={`custom-listbox-button ${open ? "open" : ""} ${articulo.diasConteo ? "selected" : "placeholder"}`}
>
{}
{Object.keys(diasConteoMap).find(key => diasConteoMap[key] === articulo.diasConteo) || "Realizar inventario"}
<span className="custom-arrow-container">
<span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{opcionesConteo.map((opcion) => (
<ListboxOption
key={opcion}
value={opcion}
className="custom-listbox-option"
>
{opcion}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
<div className='input-group number'>
<input
type="text"
name="existenciasMinimas"
placeholder="Existencias mínimas"
value={formatNumberWithDots(articulo.existenciasMinimas)}
onChange={(e) => handleArticuloChangeFormatted(e, index)}
className="input"
/>
<span className="unit">{articulo.tipoUnidad ? abreviaturas[articulo.tipoUnidad] : ""}</span>
</div>

<div className='input-group number'>
<input
type="text"
name="existenciasMaximas"
placeholder="Existencias máximas"
value={formatNumberWithDots(articulo.existenciasMaximas)}
onChange={(e) => handleArticuloChangeFormatted(e, index)}
className="input"
/>
<span className="unit">{articulo.tipoUnidad ? abreviaturas[articulo.tipoUnidad] : ""}</span>
</div>
</>
)}
{!isEditing && articulos.length > 1 && (
<button type="button" onClick={() => handleRemoveArticulo(index)} className="remove-btn">
Eliminar artículo
</button>
)}
{/* El "+" es un div con onClick, así que fieldset[disabled] no lo frena: se oculta. */}
{!isEditing && (
<div type="button" onClick={handleAddArticulo} className="add-btn-container">
<span className="add-icon">+</span><span className="add-txt">
Agregar artículo</span></div>
)}
</fieldset>
</>
))}
</div>
<div className="column long">
<div className="input-group">
<Listbox value={formData.tipoFactura} onChange={(value) => setFormData({ ...formData, tipoFactura: value })}>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${formData.tipoFactura ? 'selected' : 'placeholder'}`}>
{formData.tipoFactura || "Tipo de factura"}
<span className="custom-arrow-container">
<span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{tiposFactura.map((option) => (
<ListboxOption key={option} value={option} className="custom-listbox-option">
{option}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
<div className="input-group">
<input
type="text"
name="numeroFactura"
placeholder="Número de factura"
value={formData.numeroFactura}
onChange={handleChange}
className="input"
/>
</div>
<div className="input-group">
<Listbox value={formData.tipoDivisa} onChange={handleTipoDivisaChange} disabled={isEditing}>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${formData.tipoDivisa ? 'selected' : 'placeholder'}`}>
{formData.tipoDivisa || "Moneda de la factura"}
<span className="custom-arrow-container">
<span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{tiposDivisa.map((option) => (
<ListboxOption key={option} value={option} className="custom-listbox-option">
{option}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
<div className="input-group">
<Listbox value={formData.modalidadPago} onChange={(value) => setFormData({ ...formData, modalidadPago: value })}>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${formData.modalidadPago ? 'selected' : 'placeholder'}`}>
{formData.modalidadPago || "Modalidad de pago"}
<span className="custom-arrow-container">
<span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{modalidadesPago.map((option) => (
<ListboxOption key={option} value={option} className="custom-listbox-option">
{option}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
{formData.modalidadPago === "Cheque" && (
<>
<div className="input-group">
<input type="text" name="numeroCheque" placeholder="Número de cheque" value={formData.numeroCheque} onChange={handleChange} className="input" />
</div>
<div className="input-group">
<input type="text" name="bancoEmisor" placeholder="Banco emisor" value={formData.bancoEmisor} onChange={handleChange} className="input" />
</div>
<div className="input-group">
<label className='date-label'>Fecha de vencimiento</label>
<input type="text" inputMode="numeric" name="vencimientoCheque" placeholder="dd/mm/aaaa" value={formData.vencimientoCheque} onChange={handleFechaChange} className="input" />
</div>
<div className="input-group number">
<input
type="text"
name="montoCheque"
placeholder="Monto"
value={formatNumberWithDots(formData.montoCheque)}
onChange={handleChangeFormatted}
className="input"
/>
</div>

<div className="input-group number">
<input
type="text"
name="impuestoCheque"
placeholder="Impuesto al cheque"
value={formatNumberWithDots(formData.impuestoCheque)}
onChange={handleChangeFormatted}
className="input"
/>
</div>

</>
)}
<div className="input-group number">
<input
type="text"
name="descuentoCol2"
placeholder="Descuento aplicado"
value={formatNumberWithDots(formData.descuentoCol2)}
onChange={handleChangeFormatted}
className="input"
disabled={isEditing}
/>
<span className="unit">%</span>
</div>
<div className="input-group number">
<input
type="text"
name="ivaAplicado"
placeholder="IVA aplicado"
value={formatNumberWithDots(formData.ivaAplicado)}
onChange={handleChangeFormatted}
className="input"
disabled={isEditing}
/>
<span className="unit">%</span>
</div>
<div className="input-group number">
<input
type="text"
name="percepcionIIBB"
placeholder="Percepción IIBB"
value={formatNumberWithDots(formData.percepcionIIBB)}
onChange={handleChangeFormatted}
className="input"
disabled={isEditing}
/>
<span className="unit">%</span>
</div>
<div className="input-group number">
<input 
type="text" 
name="totalSinImpuestos" 
placeholder="Total sin impuestos" 
value={formatNumberToARS(formData.totalSinImpuestos)} 
onChange={handleChange} 
className="input" 
disabled 
/>
<span className="unit">{abreviaturasDivisa[formData.tipoDivisa] || "$"}</span>
</div>
<div className="input-group number">
<input 
type="text" 
name="totalConImpuestos" 
placeholder="Total con impuestos" 
value={formatNumberToARS(formData.totalConImpuestos)} 
onChange={handleChange} 
className="input" 
readOnly
/>
<span className="unit">{abreviaturasDivisa[formData.tipoDivisa] || "$"}</span>
</div>
{!esServicio && (
<div className="input-group number">
<input
type="text"
name="costosEnvio"
placeholder="Costos de envío"
value={formatNumberWithDots(formData.costosEnvio)}
onChange={handleChangeFormatted}
className="input"
disabled={isEditing}
/>
<span className="unit">{abreviaturasDivisa[formData.tipoDivisa] || "$"}</span>
</div>
)}
<div className="input-group">
<label className='date-label'>{esServicio ? 'Fecha de emisión' : 'Fecha de compra'}</label>
<input type="text" inputMode="numeric" name="fechaCompra" placeholder="dd/mm/aaaa" value={formData.fechaCompra} onChange={handleFechaChange} className="input" />
</div>
<div className="input-group">
<label className='date-label'>{esServicio ? 'Fecha de vencimiento' : 'Fecha de entrega'}</label>
<input type="text" inputMode="numeric" name="fechaEntrega" placeholder="dd/mm/aaaa" value={formData.fechaEntrega} onChange={handleFechaChange} className="input" />
</div>
<div className="input-group">
<label className='date-label'>Fecha de pago</label>
<input type="text" inputMode="numeric" name="fechaPago" placeholder="dd/mm/aaaa" value={formData.fechaPago} onChange={handleFechaChange} className="input" />
</div>
<div className="input-group">
<label className='date-label'>Adjuntar factura PDF</label>
<button type="button" onClick={handleButtonClick} className="pdf-button">
<ClipIcon style={{ height: '15px' }} /> Seleccionar archivo
</button>
<input
type="file"
accept="application/pdf"
onChange={handleFileChange}
ref={fileInputRef}
style={{ display: 'none' }}
/>
{pdfFile && (
<p style={{ marginLeft: '15px', cursor: 'default', fontSize: '14px', fontFamily: 'Effra', display: 'flex', alignItems: 'center', gap: '8px' }}>
{pdfFile.name}
<span
className='no-pdf'
onClick={() => setPdfFile(null)}
>
×
</span>
</p>
)}
{/* En edición, si ya hay una factura adjunta y todavía no se eligió un
    archivo nuevo, se muestra el link a la actual — si se selecciona otra,
    la reemplaza (mismo path en Storage). */}
{isEditing && !pdfFile && formData.url_factura_pdf && (
<p style={{ marginLeft: '15px', fontSize: '14px', fontFamily: 'Effra', display: 'flex', alignItems: 'center', gap: '8px' }}>
<a href={formData.url_factura_pdf} target="_blank" rel="noopener noreferrer">
Ver factura actual
</a>
</p>
)}
</div>
</div>
<div className="column long">
<label className='date-label'>Proveedor</label>
<div className="input-group">
{loadingProveedores ? (
 <LoadingSpinner />
) : (
<Combobox
value={selectedProveedor}
onChange={(selected) => {
setSelectedProveedor(selected);
if (selected) {
setFormData((prev) => ({ ...prev, ...selected, razonSocial: selected.razonSocial }));
} else {
setFormData((prev) => ({
...prev,
razonSocial: '',
cuit: '',
calle: '',
telefono: '',
correoElectronico: '',
nombreVendedor: '',
}));
}
}}
>
{({ open }) => (
<>
<div style={{ position: 'relative' }}>
<Combobox.Button
as="div"
className={`custom-listbox-button ${open ? 'open' : ''} ${
selectedProveedor ? 'selected' : 'placeholder'
}`}
style={{paddingLeft:'0',paddingRight:'0'}}
>
<Combobox.Input
className="custom-combobox-input"
onChange={(event) => setQuery(event.target.value)}
displayValue={(proveedor) => proveedor?.razonSocial || ''}
placeholder="Selecciona o busca un proveedor"
style={{
flexGrow: 1,
padding: '0',
marginLeft:'15px',
border: 'none',
outline: 'none',
backgroundColor: 'transparent',
}}
/>
<span className="custom-arrow-container" style={{marginRight:'5px'}}>
<span className="custom-arrow"></span>
</span>
</Combobox.Button>
<Combobox.Options className="custom-listbox-options">
<Combobox.Option className="custom-listbox-option" key="none" value={null}>
Ninguno
</Combobox.Option>
{filteredProveedores.length === 0 && query !== '' ? (
<div className="custom-listbox-option">No se encontraron proveedores.</div>
) : (
filteredProveedores.map((p) => (
<Combobox.Option
key={p.cuit}
value={p}
className={({ active }) =>
`custom-listbox-option ${active ? 'active' : ''}`
}
>
{p.razonSocial}
</Combobox.Option>
))
)}
</Combobox.Options>
</div>
</>
)}
</Combobox>
)}
</div>
{!selectedProveedor && (
<>
<div className="input-group"><input type="text" name="razonSocial" placeholder="Razón social" value={formData.razonSocial} onChange={handleChange} className="input" /></div>
<div className="input-group">
<input
type="text"
name="rubro"
placeholder="Rubro"
value={formData.rubro}
onChange={handleChange}
className="input"
/>
</div>
<div className="input-group"><input type="text" name="cuit" placeholder="CUIT" value={formData.cuit} onChange={handleCuitChange} maxLength={13} className="input" /></div>
<div className="input-group"><input type="text" name="calle" placeholder="Calle" value={formData.calle} onChange={handleChange} className="input" /></div>
<div style={{ display: 'flex', width: '100%', gap: '10px' }}>
<input type="text" name="altura" placeholder="Número" value={formData.altura} onChange={handleChange} className="input-address" />
<input type="text" name="piso" placeholder="Piso" value={formData.piso} onChange={handleChange} className="input-address" />
<input type="text" name="unidad" placeholder="Unidad" value={formData.unidad} onChange={handleChange} className="input-address" />
<input type="text" name="codigoPostal" placeholder="CP" value={formData.codigoPostal} onChange={handleChange} className="input-address" />
</div>
<div className="input-group"><input type="text" name="ciudad" placeholder="Ciudad / Localidad / Provincia" value={formData.ciudad} onChange={handleChange} className="input" /></div>
<div className="input-group"><input type="text" name="pais" placeholder="País" value={formData.pais} onChange={handleChange} className="input" /></div>
<div className="input-group"><input type="text" name="telefono" placeholder="Número de teléfono" value={formData.telefono} onChange={handleChange} className="input" /></div>
<div className="input-group"><input type="email" name="correoElectronico" placeholder="Correo electrónico" value={formData.correoElectronico} onChange={handleChange} className="input" /></div>
<div className="input-group"><input type="text" name="nombreVendedor" placeholder="Nombre del vendedor" value={formData.nombreVendedor} onChange={handleChange} className="input" /></div>
</>
)}
<div className="button-container" style={{}}>
<hr style={{ border: "0", borderTop: "1px solid #eaeef5", margin: "0px 0 0px" }} />
<button type="submit" className={`button ${saveState === 'saved' ? 'success' : ''}`} disabled={isLoading}>
<span className="button-text">
{saveState === 'saved'
? 'Guardado'
: isEditing ? (isLoading ? 'Guardando...' : 'Guardar cambios') : (isLoading ? 'Ingresando...' : 'Ingresar')}
</span>
{isLoading && (
<span className="progress-bar" style={{ width: `${progress}%` }}></span>
)}
</button>
{saveState === 'error' && errorMsg && (
<p className="form-error-message">{errorMsg}</p>
)}
</div>
</div>
</div>
</form>
</div>
</div>
);
};
export default ComprasForm;